



















import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";

@Component({
  components: {}
})
export default class ToolBar extends BasicComponent {

  get basketBadge() {
    return this.$store.getters.basketBadge;
  }

  goHome() {
    this.setStep(1);
  }

}

